<template>
  <v-container
      fluid
      class="home-wrapper"
      :style="{backgroundImage: `url(${backgroundImage})`}"
  >
    <v-row
        justify="center"
        :class="
        isMobileOrTablet
          ? pageWidth > 600
            ? 'padTop10'
            : pageHeight < 731
            ? 'padTop30'
            : 'padTop70'
          : pageWidth > 1600 ? '' : ''
      "
        class="home-cont"
    >
      <RiskInsiderButton/>
      <PriceGuardButton/>
      <TradeWatcherButton/>
      <PriceWatcherButton/>
      <DashboardButton/>
      <BIAnalyticsButton/>
    </v-row>
  </v-container>
</template>

<script>
import RiskInsiderButton from "@/components/Home/RiskInsiderButton.vue";
import PriceGuardButton from "@/components/Home/PriceGuardButton.vue";
import TradeWatcherButton from "@/components/Home/TradeWatcherButton.vue";
import PriceWatcherButton from "@/components/Home/PriceWatcherButton.vue";
import DashboardButton from "@/components/Home/DashboardButton.vue";
import BIAnalyticsButton from "@/components/Home/BIAnalyticsButton.vue";

export default {
  name: "Home",
  components: {
    RiskInsiderButton,
    PriceGuardButton,
    TradeWatcherButton,
    PriceWatcherButton,
    DashboardButton,
    BIAnalyticsButton
  },
  data: () => ({
    hovered: false,
  }),
  props: {
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    notificationPermission: {
      type: Boolean,
      default: false,
    },
    permisions: {
      type: String,
      default: "none",
    },
  },
  created() {
    window.scrollTo(0, 0);
    if (window.innerWidth > 320 && !this.isNotDesktop) {
      document.getElementById("htmlId").style.overflowY = "hidden";
    }
  },
  methods: {
    openAbout() {
      window.open("https://dealio.ai/", "_blank");
    },
  },
  computed: {
    backgroundImage() {
      return this.$vuetify.theme.dark ? '/img/dynamic-src-images/home-background_dark.webp' : '/img/dynamic-src-images/home-background.webp';
    },
    isMobileOrTablet() {
      return navigator.userAgent.match(
          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
      ) == null
          ? false
          : true;
    },
    pageWidth() {
      return this.$vuetify.breakpoint.width;
    },
    pageHeight() {
      return this.$vuetify.breakpoint.height;
    },
  },

  beforeRouteLeave(to, from, next) {
    document.getElementById("htmlId").style.overflowY = "auto";
    next();
  },
};
</script>

<style>
.home-cont {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  row-gap: 16px;
  justify-content: center !important;
  align-content: center;
  height: 100% !important;
  overflow-y: auto !important;
  margin-bottom: 300px;
  padding: 24px;
  padding-bottom: 200px !important;
//padding-top: 200px !important;
}

#fullWidth img {
  width: 100%;
  height: 100%;
}

#addAppsBtn .v-btn__content {
  font-size: 18px;
}

#addServersBtn .v-btn__content {
  font-size: 18px;
}

#addAppsBtn_small .v-btn__content {
  font-size: 15px;
}

#addServersBtn_small .v-btn__content {
  font-size: 15px;
}
</style>
<style scoped src="../css/utilities/scoped/home.css"></style>
